import React from "react";
import { get } from "lodash";
import InstantCriminalResult from "./InstantCriminalResult";
import PersonSearchResult from "./PersonSearchResult";
import PropertyResult from "./PropertyResult";
import SsnResult from "./SsnResult";
import CarrierLookupResult from "./CarrierLookupResult";
import BusinessResult from "./BusinessResult";
import PatriotActNimbusResult from "./PatriotActNimbusResult";
import OfacResult from "./OfacResult";
import VehicleDppaResult from "./VehicleDppaResult";
import DriverLicenseResult from "./DriverLicensesResult";
import WatercraftResult from "./WatercraftResult";
import PeopleAtWorkResult from "./PeopleAtWorkResult";
import BusinessSocialResult from "./BusinessSocialResult";
import ProfessionalLicenseResult from "./ProfessionalLicenseResult";
import HuntingFishingResult from "./HuntingFishingResult";
import ConcealedWeaponResult from "./ConcealedWeaponResult";
import PhoneNumberToNameResult from "./PhoneNumberToNameResult";
import FederalFirearmResult from "./FederalFirearmResult";
import VehicleNonDppaResult from "./VehicleNonDppaResult";
import VoterRegistrationResult from "./VoterRegistrationResult";
import MarriageDivorceResult from "./MarriageDivorceResult";
import DeathRecordsResult from "./DeathRecordsResult";
import BusinessUccNimbusResult from "./BusinessUccNimbusResult";
import PhoneNumberToNameNimbusResult from "./PhoneNumberToNameNimbusResult";
import CorporationsAndBusinessesNimbusResult from "./CorporationsAndBusinessesNimbusResult";
import CriminalMultiSectionNimbusResult from "./CriminalMultiSectionNimbusResult";
import EmailPiplResult from "./EmailPiplResult";
import SocialPiplResult from "./SocialPiplResult";

const getComponentByName = (
  root,
  resultData,
  handleReportSelection,
  resultCheckAll,
  resultItemState,
  resultRecordCount,
  handleNewSearchClick,
  previewNewSearch,
  handleHomeValueClick,
  handleMapClick,
  handleHomeIncomeClick,
  showReport,
  printContent,
  showResults,
  formData,
  additionalData
) => {
  if (additionalData === undefined) return <span />;
  if (!additionalData.menuId && additionalData.errorMessage) return <span>{additionalData.errorMessage}</span>;
  if (additionalData.menuId === 411) {
    return (
      <InstantCriminalResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (
    additionalData.menuId === 114 ||
    additionalData.menuId === 116 ||
    additionalData.menuId === 117 ||
    additionalData.menuId === 111 ||
    additionalData.menuId === 112 ||
    additionalData.menuId === 113 ||
    additionalData.menuId === 118 ||
    additionalData.menuId === 120 ||
    additionalData.menuId === 140 ||
    additionalData.menuId === 152 ||
    additionalData.menuId === 153 ||
    additionalData.menuId === 421
  ) {
    return (
      <PersonSearchResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (
    additionalData.menuId === 211 &&
    Object.keys(resultData) &&
    Object.keys(resultData).length > 0 &&
    Object.keys(resultData)[0] !== "phoneenhanceds"
  ) {
    return (
      <PhoneNumberToNameNimbusResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        optReportType={""}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 144) {
    return (
      <PersonSearchResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        optReportType={"relatives"}
        requestedSection={"relatives"}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 131) {
    return (
      <SsnResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        root={root}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 132) {
    return (
      <DeathRecordsResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        root={root}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 321) {
    return (
      <PropertyResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (
    additionalData.menuId === 211 ||
    additionalData.menuId === 212 ||
    additionalData.menuId === 215 ||
    additionalData.menuId === 216
  ) {
    return (
      <PhoneNumberToNameResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 213 || additionalData.menuId === 223) {
    return (
      <CarrierLookupResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }

  if(additionalData.menuId === 611) {
    const searchSynopsis = get(resultData, "businesss.response[0].meta[0].searchSynopsis[0]._");
    let hasEin = false;
    if(searchSynopsis) {
      const einStInd = searchSynopsis.indexOf("EIN");
      if(searchSynopsis[einStInd + "EIN".length + 1] !== ";")
        hasEin = true;
    }
    if(hasEin) {
      return (<CorporationsAndBusinessesNimbusResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />);    
    }
  }

  if (
    additionalData.menuId === 611 ||
    additionalData.menuId === 221 ||
    additionalData.menuId === 222
  ) {
    return (
      <BusinessResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }

  if (
    additionalData.menuId === 412 ||
    additionalData.menuId === 414 ||
    additionalData.menuId === 413 ||
    additionalData.menuId === 415
  ) {
    return (
      <CriminalMultiSectionNimbusResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 416) {
    return (
      <PatriotActNimbusResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 418) {
    return (
      <OfacResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }

  if (additionalData.menuId === 422 || additionalData.menuId === 621) {
    return (
      <CorporationsAndBusinessesNimbusResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 311) {
    return (
      <VehicleDppaResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 313 || additionalData.menuId === 551) {
    return (
      <DriverLicenseResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 331) {
    return (
      <WatercraftResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 614 || additionalData.menuId === 145) {
    return (
      <PeopleAtWorkResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 615) {
    return (
      <BusinessUccNimbusResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }

  if (additionalData.menuId === 612) {
    return (
      <BusinessSocialResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 511) {
    return (
      <ProfessionalLicenseResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 521) {
    return (
      <HuntingFishingResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 531) {
    return (
      <ConcealedWeaponResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 541) {
    return (
      <FederalFirearmResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 312) {
    return (
      <VehicleNonDppaResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 151) {
    return (
      <VoterRegistrationResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }

  if (additionalData.menuId === 142) {
    return (
      <PersonSearchResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        optReportType={"neighbors"}
        requestedSection={"neighbors"}
        additionalData={additionalData}
      />
    );
  }

  if (additionalData.menuId === 143) {
    return (
      <PersonSearchResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        optReportType={"common"}
        requestedSection={"common"}
        additionalData={additionalData}
      />
    );
  }

  if (additionalData.menuId === 141) {
    return (
      <MarriageDivorceResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 121 || additionalData.menuId === 711) {
    return (
      <EmailPiplResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }
  if (additionalData.menuId === 122 || additionalData.menuId === 811) {
    return (
      <SocialPiplResult
        searchResultData={resultData}
        handleReportSelection={handleReportSelection}
        resultCheckAll={resultCheckAll}
        resultItemState={resultItemState}
        resultRecordCount={resultRecordCount}
        handleNewSearchClick={handleNewSearchClick}
        previewNewSearch={previewNewSearch}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        showReport={showReport}
        printContent={printContent}
        showResults={showResults}
        formData={formData}
        additionalData={additionalData}
      />
    );
  }

  return <span />;
};

export default getComponentByName;



// WEBPACK FOOTER //
// ./src/components/searchresults/SearchResultComponentFactory.js